var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns wrapper"},[_c('div',{staticClass:"column is-three-fifths is-offset-one-fifth"},[_c('div',{staticClass:"container is-fluid"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }